import React from 'react';
import dynamic from 'next/dynamic';
import { useGate } from 'statsig-react';
import { useAuth } from '@context/auth/base';
import { useBackendUserPersistedData } from '@hooks/useBackendUserPersistedData';
import { FEATURE_GATES } from '@utils/constants';

const LazySetupProfile = dynamic(() => import('./SetupProfile').then(v => v.SetupProfile), {
  ssr: false,
});

export function SetupProfileBehindAuth() {
  const { isAuthenticatedWithAPI, authUser } = useAuth();

  const { value: enabledSetupProfileModal, isLoading: setupProfileModalFlagLoading } = useGate(
    FEATURE_GATES.SETUP_PROFILE_MODAL,
  );

  const { hasDismissedSetupProfile } = useBackendUserPersistedData();

  if (setupProfileModalFlagLoading || !enabledSetupProfileModal) return null;

  /**
   * We can stop importing with cheap checks, better logic is done inside the setup profile component
   */
  if (
    !isAuthenticatedWithAPI ||
    authUser?.artist ||
    hasDismissedSetupProfile.type !== 'not-dismissed' ||
    (authUser?.displayName && authUser.verifiedNotificationEmail)
  ) {
    return null;
  }

  return <LazySetupProfile />;
}
